export default "__VITE_ASSET__Biou2ByK__"